import constants from '../constants';

export const toggleModal = (
  isOpen: boolean,
  name: string,
  items?: object | Array<object>,
  formInstanceId?: string
) => ({
  type: constants.TOGGLE_MODAL,
  payload: { isOpen, name, items },
  formInstanceId,
});

export const initModal = (modalId: string) => ({
  type: constants.INIT_FORM,
  payload: modalId,
});
